import React from 'react';

function RemoveRowIcon() {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='16'
			height='16'
			fill='none'
			viewBox='0 0 16 16'
		>
			<path
				stroke='#141414'
				strokeLinecap='round'
				strokeLinejoin='round'
				d='M1.667 11.667c.132.729.366 1.266.78 1.69.953.976 2.486.976 5.553.976 3.067 0 4.6 0 5.553-.976.414-.424.648-.961.78-1.69M14.333 4.333c-.132-.729-.366-1.266-.78-1.69-.953-.976-2.486-.976-5.553-.976-3.067 0-4.6 0-5.553.976-.414.424-.648.961-.78 1.69M1.67 9.333c-.003-.39-.003-.858-.003-1.316 0-.457 0-.967.003-1.358m12.66 2.674c.003-.39.003-.858.003-1.316 0-.457 0-.967-.003-1.358M1.667 8h1m10.666 0h1M6 8h4'
			></path>
		</svg>
	);
}

export default RemoveRowIcon;
